import React from 'react'
import defaultClasses from './columnLine.module.css'
import { mergeClasses } from '../../classify'
import { shape, string } from 'prop-types'

/**
 * Page Builder ColumnLine component.
 *
 * This component is part of the Page Builder / PWA integration. It can be consumed without Page Builder.
 *
 * @typedef ColumnLine
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that wraps {@link Column} components.
 */
const ColumnLine = (props) => {
    const classes = mergeClasses(defaultClasses, props.classes)
    const { display, children, cssClasses } = props
    const dynamicStyles = {
        display
    }

    return (
        <div
            style={dynamicStyles}
            className={[classes.root, ...cssClasses].join(' ')}
        >
            {children}
        </div>
    )
}

/**
 * Props for {@link ColumnLine}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the ColumnLine
 * @property {String} classes.root CSS classes for the root container element
 * @property {String} display CSS display property
 */
ColumnLine.propTypes = {
    classes: shape({
        root: string
    }),
    display: string
}

export default ColumnLine
